"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditHomeCustomerDetailsPage = exports.EditHomeCustomerDetailsPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var ajax_1 = require("rxjs/ajax");
var components_1 = require("@athena-portal/components");
var React = require("react");
var StorageSuccessModal_1 = require("../../components/modals/StorageSuccessModal");
var Types_1 = require("../../Types");
var EditHomeCustomerDetailsPagePlain = /** @class */ (function (_super) {
    __extends(EditHomeCustomerDetailsPagePlain, _super);
    function EditHomeCustomerDetailsPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.redirect = function () {
            window.location.assign("/customers/".concat(_this.props.params.customerReferenceNumber));
        };
        _this.state = {
            editedEmail: undefined,
            emailValid: false,
            invalidEmailMessage: "Invalid email address",
            invalidPhoneMobileValidMessage: "Invalid phone mobile",
            confirmedEmail: undefined,
            showSuccessModal: false,
            showOverlay: false,
            editedPhoneMobile: undefined,
            phoneMobileValid: false,
            confirmedPhoneMobile: undefined
        };
        _this.resetContactDetails = _this.resetContactDetails.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.updateContactDetails = _this.updateContactDetails.bind(_this);
        _this.closeSuccessModal = _this.closeSuccessModal.bind(_this);
        return _this;
    }
    EditHomeCustomerDetailsPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.getPartyByReference(this.props.params.customerReferenceNumber).subscribe(function (customer) {
            _this.setState({
                customer: customer,
                editedEmail: customer === null || customer === void 0 ? void 0 : customer.email,
                emailValid: !!(customer === null || customer === void 0 ? void 0 : customer.email),
                confirmedEmail: customer === null || customer === void 0 ? void 0 : customer.email,
                editedPhoneMobile: customer === null || customer === void 0 ? void 0 : customer.phoneMobile,
                phoneMobileValid: !!(customer === null || customer === void 0 ? void 0 : customer.phoneMobile),
                confirmedPhoneMobile: customer === null || customer === void 0 ? void 0 : customer.phoneMobile
            });
        });
        this.supportPortalService.logAgentActivity(this.props.params.customerReferenceNumber, { "action": "No Action", "customer": this.props.params.agreementNumber })
            .subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
    };
    EditHomeCustomerDetailsPagePlain.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "home-customer-details", children: [(0, jsx_runtime_1.jsx)("div", { className: "account-details-title", children: (0, jsx_runtime_1.jsx)("h1", { className: "dashboard-panel-title font-weight-bold", children: "Edit Customer Details" }) }), this.renderEditContactDetails(), this.state.showSuccessModal &&
                    (0, jsx_runtime_1.jsx)(StorageSuccessModal_1.StorageSuccessModal, { title: "All done", explanationWording: (0, jsx_runtime_1.jsx)("p", { children: "Customer contact details have been changed and saved" }), onClose: this.closeSuccessModal })] }));
    };
    EditHomeCustomerDetailsPagePlain.prototype.renderEditContactDetails = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { className: "account-details email font-weight-bold", htmlFor: "email", children: "Email" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group m-auto", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", className: this.getInputClassName(this.state.emailValid), id: "email", value: this.state.editedEmail, onChange: this.handleChange, placeholder: "email@gmail.com" }), !this.state.emailValid ? this.renderErrorMessage(this.state.invalidEmailMessage) : ""] }), (0, jsx_runtime_1.jsx)("label", { className: "account-details email font-weight-bold pt-4", htmlFor: "email", children: "Phone number" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group m-auto", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", className: this.getInputClassName(this.state.phoneMobileValid), id: "phone", value: this.state.editedPhoneMobile, onChange: this.handleChange, placeholder: "email@gmail.com" }), !this.state.phoneMobileValid ? this.renderErrorMessage(this.state.invalidPhoneMobileValidMessage) : ""] })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "form-group float-left", id: "goBack", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-white-dashboard m-auto", onClick: this.redirect, children: "Back" }) }), (0, jsx_runtime_1.jsx)("div", { className: "form-group float-right", id: "saveChanges", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary m-auto", onClick: this.updateContactDetails, disabled: !this.contactDetailsChanged(), children: "Save changes" }) })] }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
    };
    EditHomeCustomerDetailsPagePlain.prototype.renderErrorMessage = function (message) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: message }));
    };
    EditHomeCustomerDetailsPagePlain.prototype.resetContactDetails = function () {
        this.setState(function (prevState) { return ({
            editedEmail: prevState.confirmedEmail
        }); });
    };
    EditHomeCustomerDetailsPagePlain.prototype.handleChange = function (event) {
        event.preventDefault();
        var _a = event.target, id = _a.id, value = _a.value;
        if (id === "email") {
            this.setState({
                editedEmail: value,
                emailValid: services_1.EMAIL_REGEX.test(value),
                invalidEmailMessage: "Invalid email address"
            });
        }
        if (id === "phone") {
            this.setState({
                editedPhoneMobile: value,
                phoneMobileValid: services_1.PHONE_REGEX.test(value),
            });
        }
    };
    EditHomeCustomerDetailsPagePlain.prototype.updateContactDetails = function () {
        var _this = this;
        var _a, _b, _c;
        if (this.state.emailValid) {
            this.setState({
                showOverlay: true
            });
            var user_1 = {
                email: this.state.editedEmail,
                firstName: (_a = this.state.customer) === null || _a === void 0 ? void 0 : _a.firstName,
                lastName: (_b = this.state.customer) === null || _b === void 0 ? void 0 : _b.lastName,
                mobile: this.state.editedPhoneMobile
            };
            var oldEmail_1 = (_c = this.state.customer) === null || _c === void 0 ? void 0 : _c.email;
            this.supportPortalService.updateUser(user_1, this.props.params.customerReferenceNumber)
                .subscribe(function (output) {
                var _a;
                if (output instanceof ajax_1.AjaxError) {
                    if (user_1.email !== oldEmail_1 && output.status === 409) {
                        var errorResponse = _this.parseErrorResponse(output.response);
                        if ((errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.code) === "EMAIL_ALREADY_EXISTS") {
                            _this.setState({
                                emailValid: false,
                                invalidEmailMessage: "Account with provided email address already exists.",
                                showOverlay: false
                            });
                            return;
                        }
                    }
                    _this.notificationService.push({
                        level: "ERROR",
                        message: "We are experiencing some technical issues, please come back later"
                    });
                }
                else {
                    _this.setState(function (prevState) { return ({
                        confirmedEmail: prevState.editedEmail,
                        showSuccessModal: true,
                        showOverlay: false
                    }); });
                    _this.supportPortalService.logAgentActivity(_this.props.params.customerReferenceNumber, { "action": "Edit customer details", "customer": _this.props.params.agreementNumber, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
                }
            }, function () {
                _this.setState({
                    showOverlay: false
                });
                console.log("Something went wrong");
            });
        }
    };
    EditHomeCustomerDetailsPagePlain.prototype.contactDetailsChanged = function () {
        var _a, _b;
        return this.state.editedEmail !== ((_a = this.state.customer) === null || _a === void 0 ? void 0 : _a.email) || this.state.editedPhoneMobile !== ((_b = this.state.customer) === null || _b === void 0 ? void 0 : _b.phoneMobile);
    };
    EditHomeCustomerDetailsPagePlain.prototype.closeSuccessModal = function () {
        this.setState({
            showSuccessModal: false
        });
        this.redirect();
    };
    EditHomeCustomerDetailsPagePlain.prototype.getInputClassName = function (inputValid) {
        if (inputValid == null) {
            return "form-control";
        }
        else if (inputValid) {
            return "form-control is-valid";
        }
        else {
            return "form-control is-invalid";
        }
    };
    // Local workaround for error responses that are double-serialized by ErrorResponseMessageProcessor
    // and Camel REST binding.
    EditHomeCustomerDetailsPagePlain.prototype.parseErrorResponse = function (response) {
        if (typeof response !== "string") {
            return response;
        }
        try {
            return JSON.parse(response);
        }
        catch (_a) {
            return undefined;
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], EditHomeCustomerDetailsPagePlain.prototype, "supportPortalService", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.NotificationService),
        __metadata("design:type", Object)
    ], EditHomeCustomerDetailsPagePlain.prototype, "notificationService", void 0);
    EditHomeCustomerDetailsPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], EditHomeCustomerDetailsPagePlain);
    return EditHomeCustomerDetailsPagePlain;
}(React.Component));
exports.EditHomeCustomerDetailsPagePlain = EditHomeCustomerDetailsPagePlain;
exports.EditHomeCustomerDetailsPage = (0, components_1.withRouter)(EditHomeCustomerDetailsPagePlain);
//# sourceMappingURL=EditHomeCustomerDetailsPage.js.map